import { render, staticRenderFns } from "./CoberturaCdEmExcesso.vue?vue&type=template&id=fca37b74&scoped=true"
import script from "./CoberturaCdEmExcesso.vue?vue&type=script&lang=js"
export * from "./CoberturaCdEmExcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca37b74",
  null
  
)

export default component.exports